import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/design/design/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import ComponentLayout from '~/src/layouts/component-layout';
import { Link, Text } from '@primer/react';
import { Link as GatsbyLink } from 'gatsby';
import { AccessibilityLink } from '~/src/components/accessibility-link';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = ComponentLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





    <Note variant="warning" mdxType="Note">
  <Text sx={{
        display: 'block',
        fontWeight: 'bold',
        mb: 2
      }} mdxType="Text">Guidelines for this component are in progress</Text>
  <Text mdxType="Text">Interested in contributing? Review the guidelines for <Link as={GatsbyLink} to="/guides/contribute/documentation#documenting-components" mdxType="Link">writing component documentation</Link> and open a pull request in our <Link as={GatsbyLink} to="https://github.com/primer/design" mdxType="Link">documentation repository.</Link></Text>
    </Note>
    <br />
    <img width="960" role="presentation" src="https://github.com/primer/design/assets/586552/f1ef5e7c-86fb-4131-be14-4831923065cf" alt="timeline component item" />
    <h2>{`Usage`}</h2>
    <p>{`Timeline displays items on a connected vertical timeline. It's primarily used to document the history and activity of a given pull request or issue.`}</p>
    <img width="960" role="presentation" src="https://github.com/primer/design/assets/586552/d44a8384-44fc-4879-9f1b-a4d33a53d994" alt="timeline component" />
    <h2>{`Accessibility`}</h2>
    <h3>{`Timeline breaks`}</h3>
    <p>{`The `}<inlineCode parentName="p">{`Timeline.Break`}</inlineCode>{` component allows for content in `}<inlineCode parentName="p">{`Timeline`}</inlineCode>{` to be visually seperated. This should be used for decorative purposes only. Since this component is decorative, it is not conveyed to assistive technologies like screen readers.`}</p>
    <p>{`The content within `}<inlineCode parentName="p">{`Timeline.Item`}</inlineCode>{` should clearly communicate the status and state of that item, so that if there is a need to seperate content, the context of the seperation is communicated in `}<inlineCode parentName="p">{`Timeline.Item`}</inlineCode>{`.`}</p>
    <h3>{`Known accessibility issues (GitHub staff only)`}</h3>
 <AccessibilityLink label="Timeline" mdxType="AccessibilityLink" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      